import { Component, ComponentRef, Injector, Input, NgZone, ViewContainerRef, ViewChild, OnInit, OnDestroy, inject } from '@angular/core';
import { BaseComponentWithDialog } from "../../../admin-panel/base-admin-panel/base-component-with-dialog";
import { ObjectsService } from "app/services/objects.service";
import { AccessRightsService } from "app/services/access-rights.service";

@Component({
    selector: 'app-devices-list',
    templateUrl: './devices-list.component.html',
    styleUrls: ['./devices-list.component.css'],
    standalone: false
})
export class DevicesListComponent extends BaseComponentWithDialog implements OnInit,OnDestroy {
  @Input() trackingMode: boolean;
  @Input() hiddenMode: boolean = false;
  @Input() rootID: string = "objects_top";
  @Input() groupRootID: string = "devicegroups";
  @Input() listRootID: string = "devicelist";
  @Input() pagerClass: string = "objectspager";

  groupObjectsByGroups: boolean = true;
  canEditObjects: boolean = false;
  private editObjectIds: Set<number> = new Set<number>();
  private commandObjectIds: Set<number> = new Set<number>();
  private readonly objectsService = inject(ObjectsService);
  private readonly accessRights = inject(AccessRightsService);

  constructor(protected injector: Injector) {
    super(injector);
  }
  ngOnInit() {
    super.ngOnInit();
    this.loadEditPermissions();
  }
  ngOnDestroy() {
  }

  private loadEditPermissions() {
    this.objectsService.GetObjectGroups().subscribe(groups => {
      const access = this.accessRights.getDeviceListEditAccess(groups ?? []);
      this.canEditObjects = access.canEditObjects;
      this.editObjectIds = access.editObjectIds ?? new Set<number>();
      (window as any).__objectEditAcl = access.editObjectIds;

      const commandAccess = this.accessRights.getDeviceListCommandAccess(groups ?? []);
      this.commandObjectIds = commandAccess.commandObjectIds ?? new Set<number>();
      (window as any).__objectCommandAcl = commandAccess.commandObjectIds;
    });
  }
}
